import { Organization, User } from '@paragon/contract-library';

import { AuthorizationApi } from './connections';

interface OrganizationWithUsers extends Organization {
  readonly users: readonly User[];
}

export async function pFetchUsersInOrganization(orgName: string) {
  const response = await AuthorizationApi.get<OrganizationWithUsers>(`organizations/${orgName}`, {
    params: new URLSearchParams({ withUsers: 'true' }),
  });
  return response.users;
}

export async function pFetchUserByEmail(email: string): Promise<User | null> {
  try {
    return await AuthorizationApi.get(`users/${email}`);
  } catch {
    // We've deleted some users, so we need to handle users not existing gracefully.
    return null;
  }
}
